import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../common/LoadingSpinner';
import { getAuditLog } from '../../services/api';
import { formatDateTime } from '../../utils/formatters';
import '../common/ui.css';

// Читаемые названия событий. Без них строки старых записей, где в details
// лежал только период («Август 2026»), выглядели в журнале как обрывок текста.
const ACTION_LABELS = {
  'user.create': 'Пользователь создан',
  'user.update': 'Пользователь изменён',
  'user.delete': 'Пользователь удалён',
  'org.settings_update': 'Настройки организации',
  'billing.checkout': 'Оплата тарифа',
  'billing.cancel': 'Отмена подписки',
  'billing.invoice_paid': 'Счёт оплачен',
  'billing.invoice_created': 'Счёт выставлен',
  'billing.requisites_update': 'Реквизиты',
  'billing.retention_offer': 'Скидка удержания',
  'payroll_period_closed': 'Табель закрыт',
  'payroll_period_reopened': 'Табель переоткрыт',
  'platform.impersonate_start': 'Просмотр супер-админом',
  'platform.impersonate_end': 'Просмотр завершён',
};

const AuditLogTab = () => {
  const [entries, setEntries] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getAuditLog()
      .then((data) => setEntries(data.entries || []))
      .catch(() => setError('Не удалось загрузить журнал действий'));
  }, []);

  if (error) return <div className="ui-inline-error">{error}</div>;
  if (!entries) return <LoadingSpinner />;
  if (entries.length === 0) return <div className="ui-empty">Записей пока нет</div>;

  return (
    <div className="panel audit-log-panel">
      <div className="ui-list">
        {entries.map((e) => (
          <div className="ui-list-row" key={e.id}>
            <div className="ui-list-row-title">
              <span className="audit-action">{ACTION_LABELS[e.action] || e.action}</span>
              {e.details}
            </div>
            <div className="ui-dim">
              {e.actor_name || 'Система'}{e.actor_is_platform ? ' (супер-админ)' : ''} · {formatDateTime(e.created_at)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuditLogTab;
